import { IPharmacyInfo } from "@/Common/Api/Pharmacy/Dto/Responses/IPharmacyInfo";

class PharmacyDropdownItem {
    public Pharmacy: IPharmacyInfo;
    public Active: boolean;

    public constructor(init?: Partial<PharmacyDropdownItem>) {
        Object.assign(this, init);
    }
}

export { PharmacyDropdownItem };
